// extracted by mini-css-extract-plugin
export default {"primary":"#0077c8","secondary":"#06038d","success":"#1ab759","info":"#99c9e9","danger":"#fb4e4e","orange":"#e35205","infoLight":"#dee7ff","orangeLight":"#edc8a3","dark":"#5c5c5c"};